// Add your custom JS here.

// Initialize Bootstrap tooltips
function initBootstrapTooltips() {
    if (typeof bootstrap !== 'undefined') {
        var tooltipTriggerList = jQuery('[data-bs-toggle="tooltip"]');
        tooltipTriggerList.each(function() {
            new bootstrap.Tooltip(this);
        });
    }
}

jQuery(document).ready(function() {
    initBootstrapTooltips();
});

jQuery('.faq-block').each(function () {
    var jQueryblock = jQuery(this);

    jQueryblock.find('.faq-question').on('click', function () {
        var jQueryitem = jQuery(this).closest('.faq-item');
        var jQueryanswer = jQueryitem.find('.faq-answer');

        // if already open → close it
        if (jQueryitem.hasClass('active')) {
            jQueryitem.removeClass('active');
            jQueryanswer.css('max-height', '');
            return;
        }

        // close others
        jQueryblock.find('.faq-item').removeClass('active');
        jQueryblock.find('.faq-answer').css('max-height', '');

        // open current
        jQueryitem.addClass('active');
        jQueryanswer.css('max-height', jQueryanswer.prop('scrollHeight') + 'px');
    });
});

jQuery('.qa-question').on('click', function () {
    var parent = jQuery(this).closest('.qa-item');
    var answer = parent.find('.qa-answer');

    // Close others
    jQuery('.qa-item').not(parent).removeClass('active')
        .find('.qa-answer').slideUp(250);
    jQuery('.qa-question').not(this).attr('aria-expanded', 'false');

    // Toggle current
    parent.toggleClass('active');
    answer.slideToggle(250);

    // Accessibility
    var expanded = jQuery(this).attr('aria-expanded') === 'true';
    jQuery(this).attr('aria-expanded', !expanded);
});



/**
 * Custom Tooltip with HTML Support
 * Handles tooltips with HTML content
 */
(function($) {
    'use strict';

    // Tooltip class
    class CustomTooltip {
        constructor() {
            this.activeTooltip = null;
            this.init();
        }

        init() {
            const self = this;
            
            // Handle tooltip triggers
            $(document).on('mouseenter', '[data-bs-toggle="tooltip"]', function(e) {
                self.show($(this));
            });

            $(document).on('mouseleave', '[data-bs-toggle="tooltip"]', function(e) {
                self.hide($(this));
            });

            // Handle focus for accessibility
            $(document).on('focus', '[data-bs-toggle="tooltip"]', function(e) {
                self.show($(this));
            });

            $(document).on('blur', '[data-bs-toggle="tooltip"]', function(e) {
                self.hide($(this));
            });

            // Close tooltip on scroll
            $(window).on('scroll', function() {
                self.hideAll();
            });

            // Close tooltip on window resize
            $(window).on('resize', function() {
                self.hideAll();
            });
        }

        show($element) {
            // Remove any existing tooltips first
            this.hideAll();

            const title = $element.attr('title') || $element.data('original-title');
            const placement = $element.data('bs-placement') || 'top';
            
            if (!title) return;

            // Store original title and remove it to prevent default browser tooltip
            if (!$element.data('original-title')) {
                $element.data('original-title', title);
                $element.removeAttr('title');
            }

            // Create tooltip element
            const $tooltip = $('<div>', {
                class: 'custom-tooltip',
                html: `
                    <div class="custom-tooltip-arrow"></div>
                    <div class="custom-tooltip-inner">${title}</div>
                `
            });

            // Add placement class
            $tooltip.addClass('custom-tooltip-' + placement);

            // Append to body
            $('body').append($tooltip);

            // Position the tooltip
            this.position($element, $tooltip, placement);

            // Fade in
            setTimeout(() => {
                $tooltip.addClass('show');
            }, 10);

            this.activeTooltip = $tooltip;
        }

        hide($element) {
            if (this.activeTooltip) {
                this.activeTooltip.removeClass('show');
                setTimeout(() => {
                    this.activeTooltip.remove();
                    this.activeTooltip = null;
                }, 150);
            }
        }

        hideAll() {
            $('.custom-tooltip').remove();
            this.activeTooltip = null;
        }

        position($element, $tooltip, placement) {
            const offset = $element.offset();
            const elementWidth = $element.outerWidth();
            const elementHeight = $element.outerHeight();
            const tooltipWidth = $tooltip.outerWidth();
            const tooltipHeight = $tooltip.outerHeight();
            const arrowSize = 8; // Arrow height/width in pixels
            const gap = 4; // Gap between element and tooltip

            let top, left;

            switch (placement) {
                case 'top':
                    top = offset.top - tooltipHeight - arrowSize - gap;
                    left = offset.left + (elementWidth / 2) - (tooltipWidth / 2);
                    break;

                case 'bottom':
                    top = offset.top + elementHeight + arrowSize + gap;
                    left = offset.left + (elementWidth / 2) - (tooltipWidth / 2);
                    break;

                case 'left':
                    top = offset.top + (elementHeight / 2) - (tooltipHeight / 2);
                    left = offset.left - tooltipWidth - arrowSize - gap;
                    break;

                case 'right':
                    top = offset.top + (elementHeight / 2) - (tooltipHeight / 2);
                    left = offset.left + elementWidth + arrowSize + gap;
                    break;

                default:
                    top = offset.top - tooltipHeight - arrowSize - gap;
                    left = offset.left + (elementWidth / 2) - (tooltipWidth / 2);
            }

            // Keep tooltip within viewport
            const scrollTop = $(window).scrollTop();
            const scrollLeft = $(window).scrollLeft();
            const windowWidth = $(window).width();
            const windowHeight = $(window).height();

            // Adjust horizontal position if tooltip goes off screen
            if (left < scrollLeft + 10) {
                left = scrollLeft + 10;
            } else if (left + tooltipWidth > scrollLeft + windowWidth - 10) {
                left = scrollLeft + windowWidth - tooltipWidth - 10;
            }

            // Adjust vertical position if tooltip goes off screen
            if (top < scrollTop + 10) {
                top = scrollTop + 10;
            } else if (top + tooltipHeight > scrollTop + windowHeight - 10) {
                top = scrollTop + windowHeight - tooltipHeight - 10;
            }

            $tooltip.css({
                top: top + 'px',
                left: left + 'px'
            });
        }
    }

    // Initialize when document is ready
    $(document).ready(function() {
        new CustomTooltip();
    });

})(jQuery);

/**
 * Navbar Dropdown Hover Effect
 * Makes Bootstrap 5 dropdown menus open on hover instead of click
 */
(function($) {
    'use strict';

    $(document).ready(function() {
        // Only apply on desktop (screens wider than 768px)
        function enableDropdownHover() {
            if ($(window).width() > 768) {
                // Show dropdown on mouseenter
                $('.navbar .dropdown').on('mouseenter', function() {
                    const $dropdown = $(this);
                    const $dropdownMenu = $dropdown.find('.dropdown-menu').first();
                    const $dropdownToggle = $dropdown.find('[data-bs-toggle="dropdown"]').first();
                    
                    // Don't interfere if already shown
                    if (!$dropdownMenu.hasClass('show')) {
                        $dropdownToggle.dropdown('show');
                    }
                    
                    // Stop propagation to prevent Bootstrap's click handler
                    $dropdownToggle.addClass('hover-active');
                });

                // Hide dropdown on mouseleave
                $('.navbar .dropdown').on('mouseleave', function() {
                    const $dropdown = $(this);
                    const $dropdownMenu = $dropdown.find('.dropdown-menu').first();
                    const $dropdownToggle = $dropdown.find('[data-bs-toggle="dropdown"]').first();
                    
                    if ($dropdownMenu.hasClass('show')) {
                        $dropdownToggle.dropdown('hide');
                    }
                    
                    $dropdownToggle.removeClass('hover-active');
                });

                // Prevent click event on hover-activated dropdowns (optional)
                // This allows the parent link to still be clickable
                $('.navbar .dropdown [data-bs-toggle="dropdown"]').on('click', function(e) {
                    const $this = $(this);
                    const href = $this.attr('href');
                    
                    // If the link has an href and dropdown is already shown, navigate to the link
                    if (href && href !== '#' && href !== '' && $this.hasClass('hover-active')) {
                        window.location.href = href;
                        return false;
                    }
                });
            }
        }

        // Initialize on page load
        enableDropdownHover();

        // Re-initialize on window resize (to handle desktop/mobile switch)
        let resizeTimer;
        $(window).on('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                // Remove all event handlers first
                $('.navbar .dropdown').off('mouseenter mouseleave');
                $('.navbar .dropdown [data-bs-toggle="dropdown"]').off('click');
                
                // Re-enable if still on desktop
                enableDropdownHover();
            }, 250);
        });
    });


    // Calculate and set max-width for author-role based on available space
    function adjustAuthorRoleWidth() {
        const authorNameRole = document.querySelector('.author-name-role');
        const authorName = document.querySelector('.author-name');
        const authorRole = document.querySelector('.author-role');
        console.log('Adjusting author role width...');
        if (authorNameRole && authorName && authorRole) {
            const containerWidth = authorNameRole.offsetWidth;
            const nameWidth = authorName.offsetWidth;
            let availableWidth = containerWidth - nameWidth;
            availableWidth = availableWidth - 20;
            if (availableWidth > 0) {
                authorRole.style.maxWidth = availableWidth + 'px';
            }
        }
    }

    function adjustReviewerTitleWidth() {
        const bylineReviewer = document.querySelector('.byline-reviewer');
        const reviewerName = document.querySelector('.reviewer-name');
        const reviewerTitle = document.querySelector('.reviewer-title');
        const reviewedLabel = document.querySelector('.reviewed-label');
        
        if (bylineReviewer && reviewerName && reviewerTitle && reviewedLabel) {
            const containerWidth = bylineReviewer.offsetWidth;
            const nameWidth = reviewerName.offsetWidth;
            const reviewedLabelWidth = reviewedLabel.offsetWidth;
            let availableWidth = containerWidth - nameWidth - reviewedLabelWidth;
            availableWidth = availableWidth;
            
            if (availableWidth > 0) {
                reviewerTitle.style.maxWidth = availableWidth + 'px';
            }
        }
    }

    // Run on load and resize
    window.addEventListener('load', function() {
        adjustAuthorRoleWidth();
        adjustReviewerTitleWidth();
    });
    window.addEventListener('resize', function() {
        adjustAuthorRoleWidth();
        adjustReviewerTitleWidth();
    });

})(jQuery);
